export const STATE_NAME = "taxYear";
